import { render, staticRenderFns } from "./expensePerson.vue?vue&type=template&id=2ca17dda&scoped=true"
import script from "./expensePerson.vue?vue&type=script&lang=js"
export * from "./expensePerson.vue?vue&type=script&lang=js"
import style0 from "./expensePerson.vue?vue&type=style&index=0&id=2ca17dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca17dda",
  null
  
)

export default component.exports